import { render, staticRenderFns } from "./FooterSmall.vue?vue&type=template&id=76d97e0b&scoped=true&"
import script from "./FooterSmall.vue?vue&type=script&lang=js&"
export * from "./FooterSmall.vue?vue&type=script&lang=js&"
import style0 from "./FooterSmall.vue?vue&type=style&index=0&id=76d97e0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d97e0b",
  null
  
)

export default component.exports